window.addEventListener("load", () => {

    const footer = document.getElementById('site-footer');
    if (footer) {
        function update() {
            if (footer.offsetHeight <= window.innerHeight) {
                footer.classList.add('!sticky');
            } else {
                footer.classList.remove('!sticky');
            }
        }

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(update, 100);
        });

        update();
    }

    const main = document.querySelector('main');
    if (main) {
        const firstParalax = main.querySelector(':scope > .paralax');
        if (firstParalax) {
            const nextSibling = firstParalax.nextElementSibling;
            if (nextSibling) {
                function checkParalaxVisibility() {
                    const hidden = nextSibling.getBoundingClientRect().top <= firstParalax.getBoundingClientRect().top;
                    firstParalax.classList.toggle('opacity-0', hidden);
                    firstParalax.classList.toggle('pointer-events-none', hidden);
                }
                window.addEventListener('scroll', checkParalaxVisibility, { passive: true });
                window.addEventListener('resize', checkParalaxVisibility, { passive: true });
                checkParalaxVisibility();
            }
        }
    }
    if (main) {
        let lastChild = null;
        for (let i = main.children.length - 1; i >= 0; i--) {
            const el = main.children[i];
            if (el.tagName === 'P' && !el.textContent.trim()) continue;
            lastChild = el;
            break;
        }
        if (lastChild && lastChild.classList.contains('alignfull')) {
            const bg = getComputedStyle(lastChild).backgroundColor;
            if (bg && bg !== 'rgba(0, 0, 0, 0)') {
                main.style.setProperty('--curtain-bottom-bg', bg);
            }
        }
    }

});

//# sourceMappingURL=sticky-footer.js.map
